import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export { default } from 'dayjs';
export type { Dayjs } from 'dayjs';
